import Vue from 'vue';
import VueMq from 'vue-mq';
import cssVariables from '@/assets/variables.scss';
import {
  getValueNumber,
} from '@/utils/common-utils';

Vue.use(VueMq, {
  breakpoints: {
    xs: getValueNumber(cssVariables.mediaXs),
    sm: getValueNumber(cssVariables.mediaSm),
    md: getValueNumber(cssVariables.mediaMd),
    lg: getValueNumber(cssVariables.mediaLg),
    xl: Infinity,
  },
  defaultBreakpoint: 'md',
});
